import { render, staticRenderFns } from "./we-footer-view.vue?vue&type=template&id=befd3156&scoped=true"
import script from "./we-footer-view.vue?vue&type=script&lang=js"
export * from "./we-footer-view.vue?vue&type=script&lang=js"
import style0 from "./we-footer-view.vue?vue&type=style&index=0&id=befd3156&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befd3156",
  null
  
)

export default component.exports